import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import Loader from "./components/loaderSection/loader";
import "./App.css";
import Navbar from "./components/Navbar/Navbar";
import Home from "./pages/Home";
import Features from "./pages/Features";
import Pricing from "./pages/Pricing";
import Support from "./pages/Support";
// import GetStarted from "./pages/GetStarted";
import Profile from "./pages/Profile";
import Login from "./pages/login";
import Signup from "./pages/signup";
import FeatureAiFoodDetection from "./pages/aipic";
import FeatureCalorieTracking from "./pages/caloritracking";
import FeaturePersonalReminders from "./pages/personalRemainder";


function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2500);
    return () => clearTimeout(timer);
  }, []);

  return loading ? <Loader /> : (
    <>
     <div className="bg-[#172112] min-h-screen font-manrope text-white">
     <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/features" element={<Features />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/support" element={<Support />} />
        {/* <Route path="/get-started" element={<GetStarted />} /> */}
        <Route path="/profile" element={<Profile />} />
        <Route path="/login" element={<Login />}/>
        <Route path="/signup" element={<Signup />}/>
        <Route path="/FeatureAiFoodDetection" element={<FeatureAiFoodDetection />} />
        <Route path="/calorie-tracking" element={<FeatureCalorieTracking />} />
        <Route path="/personal-reminders" element={<FeaturePersonalReminders />} />
      </Routes>
      </div>
    </>
  );
}

export default App;
